export default (theme) => ({
    '& .w5-tooltip': {
        position: 'relative',
        display: 'none',
        maxWidth: '150px',
        backgroundColor: theme.colors.grey[700],
        color: theme.colors.primary.white,
        borderRadius: '3px',
        padding: '5px',
        zIndex: '3',
        ...theme.typography.smallText,
        '& .w5-tooltip-arrow': {
            position: 'absolute',
            width: '6px',
            height: '6px',
            zIndex: '-1',
            '&:before': {
                content: '""',
                position: 'absolute',
                width: '6px',
                height: '6px',
                zIndex: '-1',
                borderRadius: '1px',
                transform: 'rotate(45deg)',
                background: theme.colors.grey[700],
            },
        },
        '&[data-popper-placement=top] > .w5-tooltip-arrow': {
            bottom: '-2px',
        },
        '&[data-popper-placement=top-start] > .w5-tooltip-arrow': {
            bottom: '-2px',
            '&:before': {
                left: '0px',
            },
        },
        '&[data-popper-placement=top-end] > .w5-tooltip-arrow': {
            bottom: '-2px',
            '&:before': {
                right: '0px',
            },
        },
        '&[data-popper-placement=bottom] > .w5-tooltip-arrow': {
            top: '-2px',
        },
        '&[data-popper-placement=bottom-start] > .w5-tooltip-arrow': {
            top: '-2px',
            '&:before': {
                left: '0px',
            },
        },
        '&[data-popper-placement=bottom-end] > .w5-tooltip-arrow': {
            top: '-2px',
            '&:before': {
                right: '0px',
            },
        },
        '&[data-popper-placement=left] > .w5-tooltip-arrow': {
            right: '-2px',
        },
        '&[data-popper-placement=left-start] > .w5-tooltip-arrow': {
            right: '-2px',
        },
        '&[data-popper-placement=left-end] > .w5-tooltip-arrow': {
            right: '-2px',
        },
        '&[data-popper-placement=right] > .w5-tooltip-arrow': {
            left: '-2px',
        },
        '&[data-popper-placement=right-start] > .w5-tooltip-arrow': {
            left: '-2px',
        },
        '&[data-popper-placement=right-end] > .w5-tooltip-arrow': {
            left: '-2px',
        },
    },
});
